export default __webpack_public_path__ + "static/media/prototype2.eaecd05a.svg";